export const ourServices = [
  {
    title: "Software Development",
    href: "/services/software-development",
  }, 
  {
    title: "Mobile Development",
    href: "/services/mobile-development",
  }, 
  {
    title: "Software Testing",
    href: "/services/software-testing",
  }, 
  {
    title: "Cloud & Deveops Services",
    href: "/services/cloud-develops-services",
  }, 
  {
    title: "Product Development",
    href: "/services/product-development",
  }, 
  {
    title: "Offshore Development",
    href: "/services/offshore-development",
  }, 
  {
    title: "Social Media Marketing",
    href: "/services/social-media-marketing",
  }, 
];